import { Editor } from '@grupoa/editor-html';
import equalWebMixin from '~/mixins/equal-web';
import { mapGetters, mapActions } from 'vuex';

const grupoaPluginsUploadTypesEnum = {
  INTERACTIVE     : 'interactive',
  BOOK            : 'book',
  LAYOUT          : 'layout',
  VIDEO_RECORDING : 'video-recording'
};

export default {
  mixins     : [equalWebMixin],
  props      : ['content', 'hover', 'title', 'configProps', 'customEditorKey'],
  components : {
    Editor
  },
  data() {
    return {
      initialContent: ''
    };
  },
  computed: {
    ...mapGetters({
      getterInstitutionConfiguration : 'plataforma/institutionConfiguration/getterInstitutionConfiguration',
      getIesAlias                    : '_core/tenant/getIesAlias',
      getTenantAlias                 : '_core/tenant/getAlias'
    })
  },
  methods: {
    ...mapActions({
      actionUploadFile: 'plataforma/upload/actionUploadFile'
    }),
    getConfig() {
      const config = this.configProps || {
        autoFocus : false,
        isInline  : false,
        readOnly  : false
      };

      const maxAudioRecordTime = this.getterInstitutionConfiguration.audioRecordingTime || 180;
      const maxVideoRecordTime = this.getterInstitutionConfiguration.audioRecordingTime || 180;
      const hasAudioRecording = this.getterInstitutionConfiguration.hasAudioRecording || false;
      const hasVideoRecording = this.getterInstitutionConfiguration.hasVideoRecording || false;
      const isPrintBookQrCode = this.getterInstitutionConfiguration.isPrintBookQrCode || false;
      const isPrintLinkQrCode = this.getterInstitutionConfiguration.isPrintLinkQrCode || false;
      const isPrintButtonQrCode = this.getterInstitutionConfiguration.isPrintButtonQrCode || false;


      if (config.customToolbar) {
        if (!hasAudioRecording) {
          config.customToolbar = config.customToolbar.replace('recordAudio', '');
        }

        if (!hasVideoRecording) {
          config.customToolbar = config.customToolbar.replace('recordVideo', '');
        }
      }

      const enforceXssSanitizer = process.env.INSTITUTIONS_WITH_XSS_SANITIZER && process.env.INSTITUTIONS_WITH_XSS_SANITIZER.split(',').includes(this.getIesAlias);

      return {
        ...config,
        ...(enforceXssSanitizer ? { xssSanitizeContentAvailable: true } : {}),
        isDarkContrastMode : this.isDarkContrastMode,
        maxAudioRecordTime,
        maxVideoRecordTime,
        isPrintBookQrCode,
        isPrintLinkQrCode,
        isPrintButtonQrCode,
        mobile             : {
          showMenuBar: false,
          ...(config.mobile || {})
        }
      };
    },
    upload(file, isInteractiveZip = false, type) {
      const params = {
        file        : file,
        tenantAlias : this.getTenantAlias,
        iesAlias    : this.getIesAlias,
        courseId    : document.referrer.split('/').pop(),
        isInteractiveZip,
        type
      };

      return this.actionUploadFile(params);
    },
    handleUpload({ payload, type }) {
      const uploadFactory = {
        [grupoaPluginsUploadTypesEnum.INTERACTIVE]     : this.handleInteractiveUpload,
        [grupoaPluginsUploadTypesEnum.BOOK]            : this.handleBookUpload,
        [grupoaPluginsUploadTypesEnum.LAYOUT]          : this.handleLayoutUpload,
        [grupoaPluginsUploadTypesEnum.VIDEO_RECORDING] : this.handleVideoRecordingUpload
      };

      uploadFactory[type](payload);
    },
    handleInteractiveUpload({ file, banner }) {
      const promises = [];

      file && promises.push(this.upload(file, true));
      banner && promises.push(this.upload(banner));

      Promise.all(promises)
        .then((files) => {
          const params = {
            file   : null,
            banner : null
          };

          files.map((file) => {
            if (file.fileName.split('.').pop().toLowerCase() === 'zip') {
              params.file = {
                url  : file.url.substring(file.url.lastIndexOf('.'), 0) + '/' + 'index.html',
                name : file.fileName,
                size : file.fileSize
              };
            } else {
              params.banner = {
                url  : file.url,
                name : file.fileName,
                size : file.fileSize
              };
            }
          });

          this.$refs.editor.saveTinymceInteractive(params);
        }).catch((e) => {
          this.$refs.editor.showError(e);
        });
    },
    handleBookUpload({ file, banner }) {
      const promises = [];

      file && promises.push(this.upload(file));
      banner && promises.push(this.upload(banner));

      Promise.all(promises)
        .then((files) => {
          const params = {
            file   : null,
            banner : null
          };

          files.map((file) => {
            if (file.fileName.split('.').pop().toLowerCase() === 'pdf') {
              params.file = {
                url  : file.url,
                name : file.fileName,
                size : file.fileSize
              };
            } else {
              params.banner = {
                url  : file.url,
                name : file.fileName,
                size : file.fileSize
              };
            }
          });

          this.$refs.editor.saveTinymceBook(params);
        }).catch((e) => {
          this.$refs.editor.showError(e);
        });
    },
    handleLayoutUpload({ file }) {
      const promise = this.upload(file);

      promise.then((result) => {
        const file = {
          url  : result.url,
          name : result.fileName,
          size : result.fileSize
        };

        this.$refs.editor.saveTinymceLayout(file);
      }).catch((e) => {
        this.$refs.editor.showError(e);
      });
    },
    handleVideoRecordingUpload({ file, type }) {
      const promise = this.upload(file, false, type);

      promise.then((result) => {
        const file = {
          url  : result.url,
          name : result.fileName,
          size : result.fileSize,
          type
        };
        this.$refs.editor.saveTinymceVideo(file);
      }).catch((e) => {
        this.$refs.editor.showError(e);
      });
    }
  }
};
